import { delegate } from "@otto-ec/global-resources/event";
import { Cinema } from "../cinema-module/cinema";
import { getElementPositionInPageContext, addFeatureOrder } from "../utils";
import { scheduleCustomerIdVerification } from "../verify";
import { createLogger } from "utils/logging";

const log = createLogger("cinema", "storefront");
log.info("Initialize StorefrontCinema");

const root = document.getElementById("ft9_benefit_cinema__root");

const featureOrder = getElementPositionInPageContext(root, "feature-order");
const cinema = new Cinema();

cinema.init(featureOrder);

scheduleCustomerIdVerification("storefront", root);

delegate(window.document, "tr-submit-tracking", ".ft9_benefit_cinema__storefront_cinema", addFeatureOrder);
